import moment from 'moment';
import { joinedValuesSeparator, dateFormat } from '@/ts/DefaultTableConfigs';

export default class CompletedOfferData {
    public id: number;
    public name: string;
    public sentDate: string;
    public moveInDate: string;
    public completedDate: string;
    public unitId: string;
    public propertyId: number;
    public address: string;
    public project: string;
    public groups: any;
    public createdBy: string;
    public email: string;
    public phone: string;
    public completedBy: string;
    public type: string;
    public removedAt: string;
    public updatedAt: string;
    public closedAt: string;

    constructor(
        id: number,
        name: string,
        sentDate: string,
        moveInDate: string,
        completedDate: string,
        unitId: string,
        propertyId: number,
        address: string,
        project: string,
        groups: any,
        createdBy: string,
        email: string,
        phone: string,
        completedBy: string,
        removedAt: string,
        updatedAt: string,
        type: string,
        closedAt: string,
    ) {
        this.id            = id;
        this.name          = name;
        this.project       = project !== null ? project : '';
        this.unitId        = unitId !== null ? unitId : '';
        this.propertyId    = propertyId !== null ? propertyId : 0;
        this.address       = address !== null ? address : '';
        this.groups        = groups.join(joinedValuesSeparator);
        this.createdBy     = createdBy !== null ? createdBy : '';
        this.email         = email !== null ? email : '';
        this.phone         = phone !== null ? phone : '';
        this.completedBy   = completedBy !== null ? completedBy : '';
        this.sentDate      = sentDate !== null ? moment(sentDate).format(dateFormat) : '';
        this.moveInDate    = moveInDate !== null ? moment(moveInDate).format(dateFormat) : '';
        this.completedDate = completedDate !== null ? moment(completedDate).format(dateFormat) : '';
        this.removedAt     = removedAt !== null ? moment(removedAt).format(dateFormat) : '';
        this.updatedAt     = updatedAt !== null ? moment(updatedAt).format(dateFormat) : '';
        this.type          = type !== null ? type : '';
        this.closedAt      = closedAt !== null ? moment(closedAt).format(dateFormat) : '';
    }
}
